import React, { useState } from 'react';
import { Box, Grid, FormControlLabel, Checkbox, Button,IconButton, Chip,Avatar, Typography, Dialog, DialogContent, DialogActions, Snackbar } from '@material-ui/core';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import { ModalHeader } from 'reactstrap';
import CloseIcon from '@material-ui/icons/Close';

import SubTasks from './SubTask';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import { useDropzone } from 'react-dropzone';
import useStyles from './index.style';

import { useDispatch, useSelector } from 'react-redux';
import { getTodayDate } from 'components/@jumbo/utils/dateHelper';
import AppTextInput from 'components/@jumbo/components/Common/formElements/AppTextInput';
import moment from 'moment'
import {isEmpty, isNull, isUndefined} from 'lodash'
import {createNewAktivitet, getAktivitetTagsByUserID, onCloseKundToaster} from 'actions'
import Alert from '@material-ui/lab/Alert';
import MuiAlert from '@material-ui/lab/Alert';
import NotyfileToaster from 'components/NotyfileToaster'
import IntlMessages from 'util/IntlMessages';

import Step1 from './Steps/Step1';
import Step2 from './Steps/Step2';
import Step3 from './Steps/Step3';

function Alert1(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const AddTask = ({ 
  isFrom,
  currentKund,
  AnsvarigId,
  open,
  handleClose,
  AvtalId,
  selectedSlot
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const authUser = useSelector(state => state.auth.authUser)
  const ListOfAVPro = useSelector(state => state.Avtal.ListOfAVPro)
  const KontakterList = useSelector(state => state.accountsData.KontakterList)
  const Aktivitetmessage = useSelector(state => state.Aktivitet.Aktivitetmessage)
  const ResponseKundMsg = useSelector(state => state.accountsData.ResponseKundMsg)


  const [openAssignedTo, setOpenAssignedTo] = useState(false);
  const [assignedTo, setAssignedTo] = useState(null);
  const [assignFor, setAssignFor] = useState(-1);
  const [attachments, setAttachments] = useState([]);

  // const [subTasks, setSubTasks] = useState([]);

  
  // const { getRootProps, getInputProps } = useDropzone({
  //   onDrop: acceptedFiles => {
  //     setAttachments(
  //       attachments.concat(
  //         acceptedFiles.map((file, index) => {
  //           return {
  //             id: index + attachments.length,
  //             name: file.name,
  //             ...file,
  //             metaData: { type: file.type, size: file.size },
  //           };
  //         }),
  //       ),
  //     );
  //   },
  // });

  const INIT_STATE = {
    error:false,
    errorMessage:<IntlMessages id="Incorrect.fields.error"/>,
    message: "",
    showMessage: false,
    KontakterList:[],
    ListOfAVPro:[],
    newAktivitet:{
        personal: 0,
        Kund:{
            KundNamn:"",
            Orgnr:"",
            Orgnr_Af:"",
            Adress:"",
            Postnr:"",
            Ort:"",
            Source:"",
            Active:""
        },
        ansvarig: authUser.user_id,
        Kontakt:{
            id:"",
            FirstName:"",
            LastName:"",
            Email:"",
            Tele:"",
            PersonNr:""
        },
        MedArbetare:[],
        SubTasks: [],
        Tags:[],
        Avtal:isUndefined(AvtalId) ? 0: AvtalId,
        AvtalType:"",
        Aktivitet:{
            type:0,
            isKlar:0,
            endDatetime:(isNull(selectedSlot) || isUndefined(selectedSlot)) ? null : moment(new Date(selectedSlot.start)).format("YYYY-MM-DD HH:mm"),
            Body:"",
            title: ""
        },
    }
  }

  const [openTooltip, setTooltipOpen] = useState(false);
  const [disabledS, setdisabledS] = useState(true);
  const [state, setState] = useState(INIT_STATE)

  const handleSetNewAktivitet = (Key, Value) => {
    setState(state => ({
      ...state,
      newAktivitet: {
        ...state.newAktivitet,
        [Key]: Value
      }
    }))
  }
  // React.useEffect(() => {
  //   setState(state => ({
  //     ...state,
  //     newAktivitet:{
  //         ...state.newAktivitet,
  //         Kund:{
  //           KundNamn:isUndefined(currentKund.Kund)?"":currentKund.Kund[0].KundNamn,
  //           Orgnr:isUndefined(currentKund.Kund)?"":currentKund.Kund[0].Orgnr,
  //           Orgnr_Af:isUndefined(currentKund.Kund)?"":currentKund.Kund[0].Orgnr_Af,
  //           Adress:isUndefined(currentKund.Kund)?"":currentKund.Kund[0].adress,
  //           Postnr:isUndefined(currentKund.Kund)?"":currentKund.Kund[0].postnr,
  //           Ort:isUndefined(currentKund.Kund)?"":currentKund.Kund[0].ort,
  //           Source:isUndefined(currentKund.Kund)?"":currentKund.Kund[0].Source,
  //           Active:isUndefined(currentKund.Kund)?"":currentKund.isActive          
  //         },
  //     }
  // }))
  // }, [currentKund])

  React.useEffect(() => {

    dispatch(getAktivitetTagsByUserID(authUser.user_id, authUser.user_Afid))

    if(!open) setState(INIT_STATE)
    if(open) setState({...INIT_STATE, newAktivitet: {...INIT_STATE.newAktivitet,  Aktivitet: {...INIT_STATE.newAktivitet.Aktivitet, endDatetime:(isNull(selectedSlot) || isUndefined(selectedSlot)) ? null : moment(new Date(selectedSlot.start)).format("YYYY-MM-DD HH:mm") }}})
  }, [open])

  React.useEffect(() => {
    if(state.KontakterList !== KontakterList){
      setState(state => ({
        ...state,
        KontakterList: KontakterList
      }))
    }
    if(state.ListOfAVPro !== ListOfAVPro){
      setState(state => ({
        ...state,
        ListOfAVPro: ListOfAVPro
      }))
    }
   
  })
  React.useEffect(() => {
    if(state.message !== Aktivitetmessage && !isEmpty(Aktivitetmessage)){
      setState(state => ({
        ...state,
        message:Aktivitetmessage,
        showMessage:!isEmpty(Aktivitetmessage)
      }))
    }
  }, [Aktivitetmessage])
  const checkInvalidation = ()=>{
    if(parseInt(state.newAktivitet.personal) === 0){
        if(isUndefined(state.newAktivitet.Kund.Orgnr)){
          setdisabledS(true) 
        }
        else if(state.newAktivitet.Kund.Orgnr ===""){
          setdisabledS(true) 
        }     
        else if(parseInt(state.newAktivitet.Aktivitet.type) === 0){
          setdisabledS(true) 
        } 
        else {
          setdisabledS(false) 
        }
      }
      else if(parseInt(state.newAktivitet.Aktivitet.type) === 0){
        setdisabledS(true) 
      }
      else{
        console.log(3,"checkInvalidation")
        setdisabledS(false) 
      }
   }
   React.useEffect(()=>{
    checkInvalidation()
   },[JSON.stringify(state.newAktivitet)])
  const onAddTask = () => {
    if(!onCheckReq()){
      const userid = authUser.user_id;
      const Afid = authUser.user_Afid;
      const Aktivitet = state.newAktivitet;
      const isKlar = state.newAktivitet.Aktivitet.isKlar;
      /*
      page:
      1 Aktivlist
      2 kund
      3 Avtal
      */
      dispatch(createNewAktivitet(userid,Afid,Aktivitet,1,isKlar,isFrom))
      
      handleClose()
      // setParentState(state => ({
      //   ...state,
      //   isLoading: true,
      //   keyword:'',
      //   datum:new Date(),
      //   filter: 0,
      // }))
    }
  };

  const removeSubTask = task => {

    setState(state => {
      return {
        ...state,
        newAktivitet: {
          ...state.newAktivitet,
          SubTasks: state.newAktivitet.SubTasks.filter(data => data.id !== task.id)
        }
      }
    })
  };

  const onChangeSubTaskTile = (title, index) => {

    setState(state => {

      let newSubTasks = [...state.newAktivitet.SubTasks]

      newSubTasks[index].title = title

      return {
        ...state,
        newAktivitet: {
          ...state.newAktivitet,
          SubTasks: newSubTasks
        }
      }
    })

  };
  const onAddSubTask = () => {

    setState(state => {
      return {
        ...state,
        newAktivitet: {
          ...state.newAktivitet,
          SubTasks: state.newAktivitet.SubTasks.concat({
              id: new Date().getTime(),
              title: '',
              completed: false,
              assignTo: null,
              collaborators: [],
          })
        }
      }
    })
  };

  const onSetCollab = (collab, index) => {
    setState(state => {

      let newSubTasks = [...state.newAktivitet.SubTasks]

      newSubTasks[index].collaborators = collab

      if(isEmpty(collab)) {
        newSubTasks[index].assignTo = null
      } else {
        newSubTasks[index].assignTo = collab[0]
      }

      return {
        ...state,
        newAktivitet: {
          ...state.newAktivitet,
          SubTasks: newSubTasks
        }
      }
    })
  }

  const onComplete = (completed, index) => {
    setState(state => {

      let newSubTasks = [...state.newAktivitet.SubTasks]

      newSubTasks[index].completed = completed

      return {
        ...state,
        newAktivitet: {
          ...state.newAktivitet,
          SubTasks: newSubTasks
        }
      }
    })
  }

  const onCheckReq=()=>{
    if(
        (isEmpty(state.newAktivitet.Kund.Orgnr) ||
        (
            parseInt(state.newAktivitet.Kontakt.id)===0
            &&
            isEmpty(state.newAktivitet.Kontakt.FirstName)
        )) && parseInt(state.newAktivitet.personal) === 0
        ||
        parseInt(state.newAktivitet.Aktivitet.type) ===0
    ){
        setState(state => ({
          ...state,
          error:true
        }))
        return true
    }else{
        setState(state => ({
          ...state,
          error:false
        }))
        return false  
    }
  }

  const handleRequestClose=()=>{
    setState(state => ({
      ...state,
      showMessage:false,
      message:''
    }))
  }

  return (
    <>
    <Dialog 
      onClose={handleClose} aria-labelledby="customized-dialog-title" 
      open={open} fullWidth={true}
      maxWidth={"md"} 
      disableBackdropClick={true} 
    >
    <ModalHeader className="modal-box-header bg-primary text-white"><IntlMessages id="the.Activity"/><IconButton className="text-white"
            onClick={handleClose}>
            <CloseIcon />
        </IconButton>
    </ModalHeader>
    <DialogContent dividers>
          <Box p={2}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormControlLabel
                  control={<Checkbox checked={state.newAktivitet.personal === 1} onChange={e => handleSetNewAktivitet('personal', (e.target.checked ? 1 : 0))} name="checkedA" />}
                  label={<IntlMessages id="Personal"/>}
                />
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  {
                    parseInt(state.newAktivitet.personal) === 0 &&
                    <Grid item xs={12} md={6}>
                      {/* Col 1 (Kund)*/}
                      <Step1 state={state} setAktivitet={handleSetNewAktivitet} setState={setState} currentKund={currentKund} AvtalId={AvtalId}/>
                    </Grid>
                  }
                  <Grid item xs={12} md={6}>
                    {/* Col 2 (Aktivitet)*/}
                    <Step2 state={state} setAktivitet={handleSetNewAktivitet} setState={setState}/>
                  </Grid>
                  <Grid item xs={12} md={parseInt(state.newAktivitet.personal) === 0 ? 12 : 6}>
                    {/* Col 3 (Checklista)*/}
                    <Typography component="div" variant="h6" className={classes.subTaskTitle}>
                    <IntlMessages id="Information"/>
                    </Typography>
                    <SubTasks
                      subTasks={state.newAktivitet.SubTasks}
                      onSubTaskAssign={onSetCollab}
                      onAddSubTask={onAddSubTask}
                      onChangeSubTaskTile={onChangeSubTaskTile}
                      removeSubTask={removeSubTask}
                      onComplete={onComplete}
                    />
                    {/* <Step3 state={state} setAktivitet={handleSetNewAktivitet} setState={setState}/>*/}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
          {/* <Box px={4}>
            <Attachments attachments={attachments} />
          </Box> */}
          {/* <Box className={classes.addTaskFooter}>
            <Box>
            
            </Box>
            <Box ml="2" display="flex" alignItems="center">
              <Button onClick={onAddTask} variant="contained" color="primary">
                <IntlMessages id="Create"/>
              </Button>

              <Box ml={2}>
                <Button onClick={onStartAddTask} className={classes.btnRoot}>
                  <IntlMessages id="Cancel"/>
                </Button>
              </Box>
            </Box>
          </Box> */}
        {/* <AssignTo
          assigned={assignedTo}
          onAssignTo={onAssignedTo}
          open={openAssignedTo}
          handleClose={() => setOpenAssignedTo(false)}
        /> */}
        
    </DialogContent> 
      {
        state.error? 
        <Alert severity="warning">{state.errorMessage}</Alert>
        :""
      }
        <DialogActions>
        <div className="d-flex w-100">
          <div>
          <Button
          onClick={handleClose}
          className="jr-btn"
          variant="outlined"
          color="default"
          ><IntlMessages id="Cancel"/></Button>
          </div> 
            <div className="ml-auto">
            <Button 
              variant="contained"
              color="primary"
              disabled={disabledS}
              className="jr-btn"
              onClick={onAddTask}
              ><IntlMessages id="Create"/></Button>
            </div> 
        </div>
        </DialogActions>
        
    </Dialog> 
    {
        isEmpty(ResponseKundMsg)?"":
        isFrom !== 3 &&
        <NotyfileToaster
        response={ResponseKundMsg}
        onCloseToaster={()=>{dispatch(onCloseKundToaster())}}
        /> 
    }
    {
      
      //   (!isEmpty(state.message) && isFrom !== 3)?
      //   <Snackbar
      //   anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      //   open={state.showMessage}
      //   autoHideDuration={3000}
      //   onClose={handleRequestClose}
      //   ContentProps={{
      //     "aria-describedby": "message-id"
      //   }}>
      //   <Alert1 onClose={handleRequestClose} 
      //   severity={state.message[0]+state.message[1] === "Er" || state.message ==='Network Error'?"error":"success"}
      //   ><span id="message-6">{state.message}</span></Alert1>
      // </Snackbar>
      //   :""
    }
    </>
  )
};

export default AddTask;
